import { IMedia } from "api/types/_media";
import { Option } from "api/types/_public";
import { CONFIG_OPTION_TOAST_ERROR, CONFIG_OPTION_TOAST_NORMAL } from "common/toast";
import CopyWrapper from "components/Common/CopyWrapper";
import LabelWrapper from "components/Common/LabelWrapper";
import ModalConfirm from "components/Common/ModalConfirm";
import TableContainer from "components/Common/TableContainer";
import TooltipCustom from "components/Common/TooltipCustom";
import { useRole } from "components/Hooks/UserHooks";
import { STATUS_MEDIA_OPTIONS, TYPE_MEDIA_OPTIONS } from "helpers/constans";
import { formatLinkHTTPS, formatNumberWithCommas } from "helpers/format";
import { isHavePermissionRole, ROLES_FOR_APP } from "helpers/role";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import CountUp from "react-countup";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { Card, CardBody, CardHeader, Col, Container, Input, Modal, ModalBody, ModalHeader, Row, Offcanvas, OffcanvasHeader, OffcanvasBody, Spinner, } from "reactstrap";
import { createSelector } from "reselect";
import { NumberParam, StringParam, useQueryParams, withDefault } from "use-query-params";
import BreadCrumb from "../../../components/Common/BreadCrumb";
import { deleteMedia, getAllAgencies, getMedias as onGetMedias } from "../../../store/thunks";
import ConfigMediaCPM from "./ConfigMediaCPM";
import FormAccount from "./FormAccount";
import FormMedia from "./FormMedia";
import ConfigAgencyCPM from "./ConfigAgencyCPM";
import { IAgency } from "api/types/_agency";
import SVGImageDefault from "components/Images/SVGImageDefault";
import DropdownAgency from "components/Common/DropdownAgency";
import DropdownStatus from "components/Common/DropdownStatus";
import { ROUTES } from "routes/allRoutes";
import DropdownOption from "components/Common/DropdownOption";

const SORT_BY_DEFAULT = 'id';
const ORDER_BY_DEFAULT = 'DESC';
const MAX_WIDTH_SCREEN = 1800;
const ManagementMedia = () => {
    const { t, i18n } = useTranslation();
    const { userPermissions } = useRole();
    const navigate = useNavigate();

    const STATUS_MEDIA_OPTIONS_LANG = STATUS_MEDIA_OPTIONS?.map((item: any) => ({ value: item?.value, label: t(item?.label) }));
    const TYPE_MEDIA_OPTIONS_LANG = TYPE_MEDIA_OPTIONS?.map((item: any) => ({ value: item?.value, label: t(item?.label) }));


    const [query, setQuery]: any = useQueryParams({
        time_request: withDefault(NumberParam, 0),
        page: withDefault(NumberParam, 1),
        limit: withDefault(NumberParam, 50),
        sort_by: withDefault(StringParam, SORT_BY_DEFAULT),
        order_by: withDefault(StringParam, ORDER_BY_DEFAULT),
        name: withDefault(StringParam, ''),
        is_active: withDefault(StringParam, STATUS_MEDIA_OPTIONS_LANG[1]?.value),
        add_type: withDefault(StringParam, ''),
        // agency_code: withDefault(StringParam, ''),
    });

    const dispatch: any = useDispatch();

    const selectLayoutState = (state: any) => state.Management;

    const ManagementProperties = createSelector(
        selectLayoutState,
        (state) => ({
            medias: state.medias,
            isMediaSuccess: state.isMediaSuccess,
            isMediaLoading: state.isMediaLoading,
            error: state.error,
        })
    );

    const { medias, isMediaLoading } = useSelector(ManagementProperties);

    const [isCallAllOptionLoading, setIsCallAllOptionLoading] = useState<boolean>(true);

    const [nameSearch, setNameSearch] = useState<string>(query?.name || "");

    const [statusSearch, setStatusSearch] = useState<Option | null>(STATUS_MEDIA_OPTIONS_LANG?.filter((item) => String(item?.value) === String(query?.is_active))[0]);

    const [typeSearch, setTypeSearch] = useState<Option | null>(TYPE_MEDIA_OPTIONS_LANG?.find((item) => String(item?.value) === String(query?.add_type)) || null);

    const [mediaDetail, setMediaDetail] = useState<IMedia | null>(null);

    const [mediaDetailChangeAccountLogin, setMediaDetailChangeAccountLogin] = useState<IMedia | null>(null);

    const [idDelete, setIdDelete] = useState<number | null>(null);
    const [isConfirmLoading, setIsConfirmLoading] = useState<boolean>(false);

    const [windowSize, setWindowSize] = useState<{ width: number, height: number }>({ width: 0, height: 0 });

    const [inventoryShowCPM, setInventoryShowCPM] = useState<any>(null);

    const [listAgency, setListAgency] = useState<IAgency[]>([]);
    const [agencySearch, setAgencySearch] = useState<Option | null>({
        label: listAgency?.find((item) => String(item?.code || '') === String(query?.agency_code || ''))?.name || t('All Agency'),
        value: `${listAgency?.find((item) => String(item?.code || '') === String(query?.agency_code || ''))?.code || ''}`
    });

    useEffect(() => {
        dispatch(onGetMedias(query));
    }, [JSON.stringify(query)]);

    const searchData = () => {
        setQuery({
            ...query,
            page: 1,
            name: nameSearch || '',
            is_active: statusSearch?.value || '',
            add_type: typeSearch?.value || '',
            agency_code: agencySearch?.value || '',
            time_request: + new Date()
        });
    };

    const resetData = () => {
        setQuery({
            name: '',
            is_active: STATUS_MEDIA_OPTIONS_LANG[1]?.value,
            add_type: '',
            agency_code: '',
            sort_by: SORT_BY_DEFAULT,
            order_by: ORDER_BY_DEFAULT,
            time_request: + new Date(),
            page: 1,
        }, "push");
        setNameSearch("");
        setStatusSearch(STATUS_MEDIA_OPTIONS_LANG[1]);
        setTypeSearch(null);
        setAgencySearch({ label: t('All Agency'), value: '' });
    };


    const handleRefresh = (isClose: boolean = true) => {
        if (isClose) { setMediaDetail((_prev) => null); }
        setQuery({ ...query, time_request: + new Date() }, "push");
    }

    const handleRefreshMediaDetailChangeAccountLogin = () => {
        setMediaDetailChangeAccountLogin((_prev) => null);
        resetData();
    }

    const navigateInventoryPage = (_media_code: string | number) => {
        navigate(`${ROUTES.MANAGEMENT_INVENTORY}?media_code=${_media_code}`);
    }

    // Column
    const columns = useMemo(
        () => [
            // {
            //     Header: t(''),
            //     accessor: "stt",
            //     filterable: false,
            //     sortable: true,
            //     thWidth: 70,
            //     thClass: 'align-middle text-start',
            //     Cell: (cell: any) => {
            //         return (<>
            //             <div className="text-start" style={{ minWidth: '50px' }}>{((query?.page - 1) * (query?.limit)) + (cell?.cell?.row?.index + 1)}</div>
            //         </>)
            //     },
            // },
            {
                Header: t('ID'),
                accessor: "id",
                filterable: true,
                sortable: true,
                Cell: (cell: any) => (
                    <>
                        <div style={{ minWidth: '40px' }}>{cell?.value}</div>
                    </>
                ),
            },
            {
                Header: t('Media'),
                accessor: "name",
                filterable: false,
                sortable: false,
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    return (
                        <>
                            <div className="d-flex align-items-center" style={{ minWidth: '170px' }}>
                                <div className="flex-shrink-0 me-2">
                                    {item?.logo_url ? <img src={item?.logo_url || ''} loading="lazy" alt={item?.name} className="avatar-sm object-fit-contain" style={{ backgroundColor: 'rgb(234 234 234 / 49%)', borderRadius: '5px' }} /> : <SVGImageDefault style={{ height: '48px' }} />}
                                </div>
                                <CopyWrapper contentCopy={item?.name} >
                                    {item?.name}
                                </CopyWrapper>
                            </div>
                        </>
                    )
                },
            },
            {
                Header: t('Type Media'),
                accessor: "add_type",
                filterable: false,
                sortable: false,
                thWidth: 100,
                thClass: 'text-center',
                Cell: (cell: any) => {
                    return (
                        <div className="text-center" style={{ minWidth: '80px' }}>
                            {TYPE_MEDIA_OPTIONS_LANG?.find((item: any) => String(item?.value) === String(cell?.value))?.label}
                        </div>
                    )
                },
            },
            {
                Header: t('Domain'),
                accessor: "website",
                filterable: false,
                sortable: false,
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    return (
                        <div style={{ minWidth: '300px' }}>
                            <span className="text-muted fs-13 me-2">{t('Domain')}:</span>{cell?.value ? <Link className='text-normal' to={formatLinkHTTPS(cell?.value)} target="_blank">
                                {cell?.value}
                            </Link> : <span className="text-muted">-</span>}
                            <br />
                            <span className="text-muted fs-13 me-2">{t('Website')}:</span> {item?.website_link ? <Link className='text-normal' to={formatLinkHTTPS(item?.website_link)} target="_blank">
                                {item?.website_link}
                            </Link> : <span className="text-muted">-</span>}
                        </div>
                    );
                },
            },
            // {
            //     Header: t('CPM'),
            //     accessor: "cpm",
            //     filterable: true,
            //     sortable: false,
            //     description: t('Cost per 1000 impressions'),
            //     thClass: 'text-center',
            //     Cell: (cell: any) => {
            //         const item = cell?.row?.original;
            //         return (
            //             <>
            //                 <div className="text-center" style={{ minWidth: '60px' }}>{formatNumberWithCommas(cell?.value || 0)}</div>

            //             </>
            //         )
            //     },
            // },
            // {
            //     Header: t('Agency'),
            //     accessor: "agency",
            //     filterable: false,
            //     sortable: false,
            //     thWidth: 100,
            //     thClass: 'text-center',
            //     Cell: (cell: any) => (
            //         <>
            //             <div className="text-center" style={{ minWidth: '80px' }}>{cell?.value?.agency_name ?? '-'}</div>
            //         </>
            //     ),
            // },
            // {
            //     Header: t('Agency CPM'),
            //     accessor: "agency_cpm",
            //     filterable: true,
            //     sortable: false,
            //     // description: t('Cost per 1000 impressions'),
            //     thClass: 'text-center',
            //     Cell: (cell: any) => {
            //         const item = cell?.row?.original;
            //         return (
            //             <>
            //                 <div className="text-center" style={{ minWidth: '90px' }}>{formatNumberWithCommas(item?.agency?.agency_media_cpm || 0)}</div>
            //             </>
            //         )
            //     },
            // },
            {
                Header: t('Inventory'),
                accessor: "inventory_count",
                filterable: false,
                sortable: false,
                thWidth: 100,
                thClass: 'text-center',
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    return (
                        <>
                            <div className="text-center text-primary cursor-pointer hover-underline" onClick={() => navigateInventoryPage(item?.code)} style={{ minWidth: '80px' }}>{cell?.value ?? '-'}</div>
                        </>
                    )
                },
            },
            {
                Header: t('Status'),
                accessor: "is_active",
                filterable: false,
                sortable: false,
                thWidth: 100,
                thClass: 'text-center',
                Cell: (cell: any) => {
                    return (
                        <div className="text-center" style={{ minWidth: '80px' }}>
                            <span className={`rounded-pill badge bg-${['danger', 'success'][cell?.value] || 'secondary'}`}>{STATUS_MEDIA_OPTIONS_LANG?.find((item: any) => String(item?.value) === String(cell?.value))?.label}</span>
                        </div>
                    )
                },
            },
            {
                Header: t('Created at'),
                accessor: "created_at",
                filterable: true,
                sortable: false,
                thWidth: 150,
                thClass: 'text-end',
                Cell: (cell: any) => {
                    const arrDate = String(cell?.value || '').split(' ');
                    return (
                        <div className="text-end" style={{ minWidth: '120px' }}>
                            <span><span>{arrDate?.[0] || ''}</span> <br /> <span className="text-secondary">{arrDate?.[1] || ''}</span> </span>
                        </div>
                    )
                },
            },

            {
                Header: t('Updated at'),
                accessor: "updated_at",
                filterable: true,
                sortable: false,
                thWidth: 150,
                thClass: 'text-end',
                Cell: (cell: any) => {
                    const arrDate = String(cell?.value || '').split(' ');
                    return (
                        <div className="text-end" style={{ minWidth: '120px' }}>
                            <span><span>{arrDate?.[0] || ''}</span> <br /> <span className="text-secondary">{arrDate?.[1] || ''}</span> </span>
                        </div>
                    )
                },
            },
            {
                Header: t('Action'),
                thClass: 'text-center',
                thWidth: 150,
                Cell: (cell: any) => {
                    const item: any = cell?.row?.original;
                    return (
                        <div className="text-center" style={{ minWidth: '120px' }}>
                            <ul className="list-inline justify-content-center hstack gap-2 mb-0">
                                <TooltipCustom
                                    title={t('Button Detail Media')}
                                    id={`detail-cp-${item?.id}`}
                                >
                                    <li className="list-inline-item edit " title="Edit">
                                        <Link className="btn btn-sm btn-soft-secondary d-inline-block edit-item-btn" to="#"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                setMediaDetail((_prev) => ({ ...item, is_preview: true }));
                                            }}>
                                            <i className="ri-eye-fill"></i>
                                        </Link>
                                    </li>
                                </TooltipCustom>
                                {/* {isHavePermissionRole(ROLES_FOR_APP.MEDIA_CONFIG_CPM, userPermissions) && (<TooltipCustom
                                    title={t('Button Config CPM')}
                                    id={`update-cp-${item?.id}`}
                                >
                                    <li className="list-inline-item edit " title="CPM">
                                        <Link className="btn btn-sm btn-soft-warning d-inline-block edit-item-btn" to="#"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                setInventoryShowCPM((_prev: any) => ({ ...item?.inventory, media: item }));
                                            }}>
                                            <i className="ri-shield-star-fill"></i>
                                        </Link>
                                    </li>
                                </TooltipCustom>)} */}
                                {isHavePermissionRole(ROLES_FOR_APP.MEDIA_CONFIG_ACCOUNT_LOGIN, userPermissions) && (<TooltipCustom
                                    title={t('Button Update Account Login Media')}
                                    id={`update-cp-${item?.id}`}
                                >
                                    <li className="list-inline-item edit " title="Edit">
                                        <Link className="btn btn-sm btn-soft-success d-inline-block edit-item-btn" to="#"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                setMediaDetailChangeAccountLogin((_prev) => item);
                                            }}>
                                            <i className="ri-user-3-fill"></i>
                                        </Link>
                                    </li>
                                </TooltipCustom>)}

                                {isHavePermissionRole(ROLES_FOR_APP.MEDIA_UPDATE, userPermissions) && (<TooltipCustom
                                    title={t('Button Update Media')}
                                    id={`update-cp-${item?.id}`}
                                >
                                    <li className="list-inline-item edit " title="Edit">
                                        <Link className="btn btn-sm btn-soft-primary d-inline-block edit-item-btn" to="#"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                setMediaDetail((_prev) => item);
                                            }}>
                                            <i className="ri-pencil-fill"></i>
                                        </Link>
                                    </li>
                                </TooltipCustom>)}
                                {isHavePermissionRole(ROLES_FOR_APP.MEDIA_DELETE, userPermissions) && (<TooltipCustom
                                    title={t('Button Delete Media')}
                                    id={`detail-cp-${item?.id}`}
                                >
                                    <li className="list-inline-item" title="Remove">
                                        <Link className="btn btn-sm btn-soft-danger d-inline-block edit-item-btn" to="#"
                                            onClick={(e) => { e.preventDefault(); handleConfirmDelete(item) }}
                                        >
                                            <i className="ri-delete-bin-5-fill"></i>
                                        </Link>
                                    </li>
                                </TooltipCustom>)}
                            </ul>
                        </div>
                    );
                },
            },
        ],
        [i18n?.language, userPermissions, JSON.stringify(query), STATUS_MEDIA_OPTIONS_LANG]
    );

    const handleChangePage = useCallback((page: any) => {
        setQuery({ page: page + 1 })
    }, []);

    const handleChangeSorting = useCallback((sortBy: any) => {
        setQuery((_prev: any) => {
            return ({ ..._prev, ...sortBy });
        });
    }, []);

    // Begin::Delete
    const handleConfirmDelete = (item: IMedia) => {
        setIdDelete((_prev) => item?.id);
    };

    const handleActionDelete = async () => {
        if (!idDelete) { return; };
        try {
            setIsConfirmLoading((_prev) => true);
            const response: any = await deleteMedia(idDelete);
            if (response?.code === 200) {
                dispatch(onGetMedias(query));
                setIsConfirmLoading((_prev) => false);
                setIdDelete((_prev) => null);
                toast(`${t('The process has been completed.')}`, CONFIG_OPTION_TOAST_NORMAL);
            } else {
                setIsConfirmLoading((_prev) => false);
                toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
            }
        } catch (error: any) {
            setIsConfirmLoading((_prev) => false);
            toast(`${error?.message || ''}`, CONFIG_OPTION_TOAST_ERROR);
            return error;
        }
    };

    const onCloseConfirmClick = () => {
        setIdDelete((_prev) => null);
    }
    // End::Delete

    const handleActionRefresh = () => {
        dispatch(onGetMedias(query));
    }

    useEffect(() => {
        const handleCallAllOption = async () => {
            try {
                // setIsCallAllOptionLoading((_prev) => true);
                // const [resAgency]: any = await Promise.all([getAllAgencies()]);
                setIsCallAllOptionLoading((_prev) => false);
                // const list_a = ([{ name: t('All Agency'), id: '', code: '' } as any]).concat(resAgency?.data || []);
                // const agency = list_a?.find((item) => String(item?.code || '') === String(query?.agency_code || '')) || null;
                // setListAgency((_prev) => list_a);
                // setAgencySearch((_prev) => ({
                //     label: agency?.name || t('All Agency'),
                //     value: agency?.code || '',
                // }));
            } catch (error: any) {
                setIsCallAllOptionLoading((_prev) => false);
                return error;
            }
        };
        handleCallAllOption();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (agencySearch) {
            setListAgency((_prev) => (_prev || [])?.map((item) => item?.id ? item : ({ ...item, name: t('All Agency') })));
            (!agencySearch?.value) && setAgencySearch((prev) => ({ label: t('All Agency'), value: '' }));
        }

        document.title = `${t("Media Management")} - ${t("Ads Management")} | AdsHub`;
        document.body.classList.remove("vertical-sidebar-enable");
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [i18n?.language]);

    useEffect(() => {
        function handleResize() {
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight,
            });
        }
        window.addEventListener('resize', handleResize);
        handleResize();
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <BreadCrumb title={t('Media Management')} pageTitle={t('Ads Management')} />
                    {isHavePermissionRole(ROLES_FOR_APP.MANAGEMENT_MEDIA, userPermissions) && (
                        <Row>
                            <Col sm={12} md={12}>
                                <Card id="customerList" style={{ boxShadow: '0px 3px 4px 0px rgba(0, 0, 0, 0.03)' }}>
                                    <CardHeader className="border-0">
                                        <Row className="g-4 align-items-center">
                                            <div className="col-6">
                                                <div>
                                                    <h5 className="card-title mb-0">
                                                        <span className="me-2">{t('Total')}:</span>
                                                        {
                                                            isMediaLoading ? <Spinner size="sm" className="text-primary" ></Spinner> : (
                                                                <CountUp
                                                                    start={0}
                                                                    end={medias?.pagination?.total || 0}
                                                                    duration={1}
                                                                    className="text-primary"
                                                                />
                                                            )
                                                        }
                                                    </h5>
                                                </div>
                                            </div>
                                            {isHavePermissionRole(ROLES_FOR_APP.MEDIA_CREATE, userPermissions) && (<div className="col-6 text-end">
                                                <div>
                                                    <button
                                                        type="button"
                                                        className="btn btn-success add-btn rounded-pill"
                                                        id="create-btn"
                                                        onClick={() => setMediaDetail((_prev) => ({} as IMedia))}
                                                    >
                                                        <i className="ri-add-line align-bottom me-1"></i>
                                                        {t('Button Create Media')}
                                                    </button>
                                                </div>
                                            </div>)}
                                        </Row>
                                    </CardHeader>
                                    <div className=" border border-dashed border-end-0 border-start-0 card-body mt-0 pb-4">
                                        <Row className="g-4 align-items-center mt-0">
                                            {/* <Col sm={12} md={6} xl={2} xxl={2} className='mt-3 mt-xl-2'>
                                                <LabelWrapper label={t('Agency')} isShow={!!agencySearch?.value}>
                                                    <DropdownAgency
                                                        name="agency"
                                                        typeValue="code"
                                                        dataList={listAgency}
                                                        initialValue={agencySearch}
                                                        onChangeSelect={(event: any) => {
                                                            setAgencySearch((_prev) => event);
                                                        }}
                                                    />
                                                </LabelWrapper>
                                            </Col> */}
                                            <Col sm={12} md={6} xl={3} xxl={3} className='mt-3 mt-xl-2'>
                                                <LabelWrapper label={t('Media')} isShow={!!nameSearch}>
                                                    <Input
                                                        type="text"
                                                        className="form-control search"
                                                        placeholder={`${t('Media')}...`}
                                                        value={nameSearch}
                                                        onChange={(e) => setNameSearch(e.target.value)}
                                                        onKeyDown={(e) => {
                                                            if (e.key === "Enter") {
                                                                searchData();
                                                            }
                                                        }}
                                                    />
                                                </LabelWrapper>
                                            </Col>
                                            <Col sm={12} md={6} xl={2} xxl={2} className='mt-3 mt-xl-2'>
                                                <LabelWrapper label={t('Type Media')} isShow={true}>
                                                    <DropdownOption
                                                        name="status"
                                                        dataList={TYPE_MEDIA_OPTIONS_LANG || []}
                                                        placeholder={`${t("Type Media")}...`}
                                                        className="dropdown-status-rounded"
                                                        classNamePrefix="name-prefix"
                                                        initialValue={typeSearch || null}
                                                        onChangeSelect={(e: any) => setTypeSearch(e)}
                                                        isHasOptionAll={true}
                                                        optionAll={{ label: t('All'), value: '' }}
                                                    />
                                                </LabelWrapper>
                                            </Col>
                                            <Col sm={12} md={6} xl={2} xxl={2} className='mt-3 mt-xl-2'>
                                                <LabelWrapper label={t('Status')} isShow={!!statusSearch?.value}>
                                                    <DropdownStatus
                                                        name="status"
                                                        dataList={STATUS_MEDIA_OPTIONS_LANG || []}
                                                        placeholder={`${t("Status")}...`}
                                                        className="dropdown-status-rounded"
                                                        classNamePrefix="name-prefix"
                                                        initialValue={statusSearch || null}
                                                        onChangeSelect={(e: any) => setStatusSearch(e)}
                                                        isHasOptionAll={true}
                                                        optionAll={{ label: t('All Status'), value: '' }}
                                                        colors={['danger', 'success']}
                                                    />
                                                </LabelWrapper>
                                            </Col>
                                            <Col sm={12} md={6} xl={3} xxl={3} className="hstack gap-1 justify-content-center justify-content-sm-end justify-content-xl-between mt-3 mt-xl-2">
                                                <div>
                                                    <button
                                                        type="button"
                                                        className="btn btn-primary me-2 "
                                                        onClick={searchData}
                                                        disabled={(isMediaLoading || isCallAllOptionLoading)}
                                                    >
                                                        {(isMediaLoading || isCallAllOptionLoading) ? <div className="me-1" style={{ display: 'inline-table', verticalAlign: 'top' }}><Spinner size="sm" style={{ width: '14px', height: '14px' }}></Spinner></div> : <i className="ri-search-line align-bottom me-1"></i>}{" "}
                                                        {t('Button Search')}
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className="btn btn-secondary fs-14"
                                                        onClick={resetData}
                                                    >
                                                        <i className="ri-refresh-line align-bottom me-1"></i>{" "}
                                                        {t('Button Reset')}
                                                    </button>
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                    <CardBody className="pt-3">
                                        <TableContainer
                                            className="custom-header-css"
                                            divClass="table-responsive table-card"
                                            tableClass="align-middle table-bordered-dashed"
                                            theadClass="table-light text-muted"
                                            columns={columns}
                                            data={medias?.list?.length ? medias?.list : []}
                                            customPageSize={query.limit}
                                            customPageIndex={query.page - 1}
                                            totalRecords={medias?.pagination?.total}
                                            customPageCount={Math.ceil(Number(medias?.pagination?.total) / Number(medias?.pagination?.limit))}
                                            handleChangePage={handleChangePage}
                                            manualSorting={true}
                                            sorting={{ sort_by: query.sort_by, order_by: query.order_by }}
                                            handleChangeSorting={handleChangeSorting}
                                            isLoading={isMediaLoading}
                                        />
                                    </CardBody>
                                </Card>
                            </Col>
                            {((windowSize?.width >= MAX_WIDTH_SCREEN)) && (
                                <Offcanvas
                                    fade
                                    scrollable={false}
                                    direction="end"
                                    isOpen={(mediaDetail !== null)}
                                    id="offcanvasExample"
                                    className='off-canvas-lg'
                                >
                                    <OffcanvasHeader className="bg-light" toggle={() => setMediaDetail((_prev) => null)}>
                                        <h5 className="fs-16 mb-1">{!!mediaDetail?.id ? (!!mediaDetail?.is_preview ? t('Button Detail Media') : t('Button Update Media')) : t('Button Create Media')}</h5>
                                    </OffcanvasHeader>
                                    <OffcanvasBody className="color-scrollbar-os">
                                        <FormMedia detail={mediaDetail} agencies={(listAgency || [])?.filter((item) => !!item?.id)} triggerRefresh={handleRefresh} handleClose={() => setMediaDetail((_prev) => null)} />
                                    </OffcanvasBody>
                                </Offcanvas>
                            )}
                            {(windowSize?.width < MAX_WIDTH_SCREEN) && (<Modal
                                isOpen={mediaDetail !== null}
                                centered={true}
                                size="md"
                                toggle={() => setMediaDetail((_prev) => null)}
                                keyboard={true}
                            >
                                <ModalHeader toggle={() => setMediaDetail((_prev) => null)}>
                                    {!!mediaDetail?.id ? (!!mediaDetail?.is_preview ? t('Button Detail Media') : t('Button Update Media')) : t('Button Create Media')}
                                </ModalHeader>
                                <ModalBody className="">
                                    <FormMedia detail={mediaDetail} agencies={(listAgency || [])?.filter((item) => !!item?.id)} triggerRefresh={handleRefresh} handleClose={() => setMediaDetail((_prev) => null)} />
                                </ModalBody>
                            </Modal>)}
                        </Row>
                    )}
                    <ToastContainer closeButton={false} limit={1} />
                </Container>
            </div>
            <Modal
                isOpen={mediaDetailChangeAccountLogin !== null}
                centered={true}
                size="md"
                toggle={() => setMediaDetailChangeAccountLogin((_prev) => null)}
                keyboard={true}
            >
                <ModalHeader toggle={() => setMediaDetailChangeAccountLogin((_prev) => null)}>
                    {t('Button Update Account Login Media')}
                </ModalHeader>
                <ModalBody className="">
                    <FormAccount detail={mediaDetailChangeAccountLogin} triggerRefresh={handleRefreshMediaDetailChangeAccountLogin} handleClose={() => setMediaDetailChangeAccountLogin((_prev) => null)} />
                </ModalBody>
            </Modal>
            <Modal isOpen={!!inventoryShowCPM} centered={true} scrollable={true} size="xl modal-xxll">
                <ModalHeader toggle={() => setInventoryShowCPM((prev: any) => (prev ? null : prev))}>
                    {t('Button Config CPM')}
                </ModalHeader>
                <ModalBody className="py-3 pt-0 px-4">
                    <div style={{ minHeight: '450px' }}>
                        <Row>
                            <Col md={12} lg={6}>
                                <ConfigMediaCPM
                                    mediaCode={inventoryShowCPM?.media?.code}
                                    media={inventoryShowCPM?.media}
                                    handleActionRefresh={handleActionRefresh}
                                    handleCloseModal={() => setInventoryShowCPM((prev: any) => (null))}
                                />
                            </Col>
                            <Col md={12} lg={6}>
                                <ConfigAgencyCPM
                                    mediaCode={inventoryShowCPM?.media?.code}
                                    agencyCode={inventoryShowCPM?.media?.agency?.agency_code}
                                    media={inventoryShowCPM?.media}
                                    handleActionRefresh={handleActionRefresh}
                                    handleCloseModal={() => setInventoryShowCPM((prev: any) => (null))}
                                />
                            </Col>
                        </Row>
                    </div>
                </ModalBody>
            </Modal>
            <ModalConfirm
                header={t('Button Delete Media')}
                isOpen={idDelete !== null}
                isLoading={isConfirmLoading}
                onClose={onCloseConfirmClick}
                onConfirm={handleActionDelete}
            />
        </React.Fragment>
    );
};

export default ManagementMedia;